import React from 'react';
import { X } from 'lucide-react';

/**
 * Composant Modal moderne réutilisable
 * Fournit un design cohérent pour tous les modals de l'application
 */
const ModernModal = ({ 
  children, 
  onClose, 
  title, 
  size = 'md', 
  showCloseButton = true,
  className = ''
}) => {
  const sizeClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl'
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Overlay avec animation */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity duration-300 ease-in-out"
        onClick={onClose}
      />
      
      {/* Modal container */}
      <div className="flex min-h-full items-center justify-center p-4">
        {/* Modal content avec animation */}
        <div 
          className={`
            relative w-full ${sizeClasses[size]} 
            transform overflow-hidden rounded-2xl bg-white shadow-2xl 
            transition-all duration-300 ease-in-out
            animate-fade-in-up
            ${className}
          `}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          {title && (
            <div className="border-b border-gray-100 bg-gradient-to-r from-blue-50 to-indigo-50 px-6 py-4">
              <div className="flex items-center justify-between">
                <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
                {showCloseButton && (
                  <button
                    onClick={onClose}
                    className="rounded-lg p-2 text-gray-400 hover:bg-white hover:text-gray-600 
                             transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <X size={20} />
                  </button>
                )}
              </div>
            </div>
          )}
          
          {/* Content */}
          <div className="max-h-[80vh] overflow-y-auto">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModernModal;
